function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t\t.st12{display:inline;}\r\n\t\t.st13{fill:#231F20;}\r\n\t");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "transfer"
}, /*#__PURE__*/React.createElement("g", {
  className: "st12"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M85.4,85.4c-19.5,19.5-51.2,19.5-70.7,0c-19.5-19.5-19.5-51.2,0-70.7c19.5-19.5,51.2-19.5,70.7,0 C104.9,34.1,104.9,65.9,85.4,85.4z M17,17C-1.2,35.2-1.2,64.8,17,83c18.2,18.2,47.8,18.2,66,0c18.2-18.2,18.2-47.8,0-66 C64.8-1.2,35.2-1.2,17,17z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M62.6,66.3c-0.4,0.4-1,0.6-1.5,0.6c-0.6,0-1.1-0.2-1.5-0.6c-0.4-0.4-0.6-0.9-0.6-1.5l0.3-21L40,63 c-0.8,0.8-2.2,0.8-3,0c-0.8-0.8-0.8-2.2,0-3l19.3-19.3l-21,0.3c-0.6,0-1.1-0.2-1.5-0.6c-0.4-0.4-0.6-0.9-0.6-1.5 c0-0.6,0.2-1.1,0.6-1.5c0.4-0.4,0.9-0.6,1.5-0.6l26-0.4l0.1,0l0.2,0c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0 c0.2,0.1,0.5,0.2,0.7,0.3c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.2,0.2,0.4,0.3,0.7c0,0.1,0,0.1,0,0.2 c0,0.1,0,0.2,0,0.3l0,0.2l0,0.1l-0.4,26C63.2,65.4,63,65.9,62.6,66.3z"
})))));

var SvgTransfer = function SvgTransfer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransfer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transfer.4c2b0737.svg";
export { ForwardRef as ReactComponent };